module.exports = __webpack_public_path__ + "img/BYOCS_Icons_SDOH_Education_noBG.96930733.png";